import { MentionData } from "@draft-js-plugins/mention";
import Fuse from "fuse.js";

export const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const removeFromList = (list: any, index: any) => {
  const result = Array.from(list);
  const [removed] = result.splice(index, 1);
  return [removed, result];
};

export const addToList = (list: any, index: any, element: any) => {
  const result = Array.from(list);
  result.splice(index, 0, element);
  return result;
};

export const customSuggestionsFilter = (searchValue: string, suggestions: MentionData[]) => {
  const options = {
    useExtendedSearch: true,
    keys: ["name"], // search by name
  };

  const fuse = new Fuse(suggestions, options);

  const searchValueConvert = searchValue.split(" ").map((word) => ({
    name: `'` + word,
  }));

  const filteredSuggestions = searchValue
    ? fuse.search({ $and: searchValueConvert }).map((result) => result.item)
    : suggestions;

  return filteredSuggestions;
};

type ReactionType = "like" | "dislike";

export const targetKeyScreen = {
  ACTIVITY: 'resourcecmt',
  START: 'comment'
}

export const handleReaction = ({
  type,
  toggle,
  data,
  setData,
  targetKey = 'resourcecmt'
}: {
  type: ReactionType,
  toggle: boolean,
  data: any[],
  setData?: (updater: (prev: any[]) => any[]) => void,
  targetKey?: string
}) => {
  let key: string
  let oppositeKey: string

  if(targetKey == 'resourcecmt') {
    key = type === "like" ? "resourcesLikes" : "resourcesDislikes";
    oppositeKey = type === "like" ? "resourcesDislikes" : "resourcesLikes";
  
  }
  else if(targetKey == 'comment') {
    key = type === "like" ? "likes" : "dislikes";
    oppositeKey = type === "like" ? "dislikes" : "likes";
  }

  setData &&
    setData((prev: any[]) => {
      return prev.map((item) => {
        const target = item?.[targetKey];
   
        const resourceId = target?.id || target?.comment_id;
        const currentReactions = target?.[key] || [];
        const currentOppositeReactions = target?.[oppositeKey] || [];

        const relevantReactions = data?.filter(
          (r: any) => r.resourcesId === resourceId
        );

        if (toggle) {
          const newReactions = relevantReactions.filter(
            (r: any) =>
              !currentReactions.some(
                (existing: any) =>
                  existing.userId === r.userId &&
                  existing.resourcesId === r.resourcesId
              )
          );

          const cleanedOpposite = currentOppositeReactions.filter(
            (r: any) =>
              !relevantReactions.some(
                (d: any) =>
                  d.userId === r.userId &&
                  d.resourcesId === r.resourcesId
              )
          );

          return {
            ...item,
            [targetKey]: {
              ...target,
              [key]: [...currentReactions, ...newReactions],
              [oppositeKey]: cleanedOpposite,
            },
          };
        } else {
          const updatedReactions = currentReactions.filter(
            (r: any) =>
              !relevantReactions.some(
                (d: any) =>
                  d.userId === r.userId &&
                  d.resourcesId === r.resourcesId
              )
          );

          return {
            ...item,
            [targetKey]: {
              ...target,
              [key]: updatedReactions,
            },
          };
        }
      })
    });
};
